import type { Special } from "@/types";

export const specials: Special[] = [
  {
    id: 1,
    title: "年度最佳韩剧盘点",
    subtitle: "编辑部票选 · 2024—2025",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20collage%20inspired%20Korean%20drama%20awards%20theme%20with%20warm%20pink%20and%20gold%20accents%2C%20premium%20magazine%20cover%20style&width=1200&height=700&seq=special-cover-01&orientation=landscape",
    intro: "从口碑到话题度，我们综合编辑部评分与观众讨论，选出近年来最值得一看的韩剧，帮你一次看个够。",
    groups: [
      { title: "口碑之选", desc: "评分与剧本双高的作品", dramaIds: [2, 4, 7] },
      { title: "话题之作", desc: "开播即引发全网讨论", dramaIds: [1, 11, 9] },
      { title: "治愈必看", desc: "适合慢慢品味的小而美", dramaIds: [3, 10, 12] },
    ],
    relatedSpecialIds: [2, 3],
  },
  {
    id: 2,
    title: "新剧速递 · 2025 秋季档",
    subtitle: "本月上新 · 追剧风向标",
    cover: "https://readdy.ai/api/search-image?query=Autumn%20Seoul%20cityscape%20with%20warm%20golden%20leaves%20and%20city%20lights%2C%20editorial%20magazine%20style%20cover&width=1200&height=700&seq=special-cover-02&orientation=landscape",
    intro: "秋季档新剧集中上线，爱情、悬疑、科幻一网打尽，这份清单帮你快速锁定本季必追。",
    groups: [
      { title: "即将开播", desc: "首播日历已经排好", dramaIds: [1, 5, 8] },
      { title: "热播中", desc: "正在更新的高热度作品", dramaIds: [9, 11] },
      { title: "口碑黑马", desc: "低开高走的惊喜之作", dramaIds: [7, 4] },
    ],
    relatedSpecialIds: [1, 3],
  },
  {
    id: 3,
    title: "悬疑剧场 · 烧脑合集",
    subtitle: "推理爱好者专区",
    cover: "https://readdy.ai/api/search-image?query=Moody%20detective%20theme%20editorial%20cover%20with%20dark%20tones%20and%20warm%20orange%20accents%2C%20cinematic%20magazine%20style&width=1200&height=700&seq=special-cover-03&orientation=landscape",
    intro: "如果你喜欢在细节里找线索、在反转中惊叹，这几部悬疑推理剧一定能让你一夜追完。",
    groups: [
      { title: "本格推理", desc: "线索公平、逻辑严密", dramaIds: [2, 7] },
      { title: "动作追凶", desc: "紧张刺激、节奏飞快", dramaIds: [11] },
      { title: "心理博弈", desc: "在人性深处寻找真相", dramaIds: [2, 11] },
    ],
    relatedSpecialIds: [1, 4],
  },
  {
    id: 4,
    title: "下饭甜宠 · 轻松追剧",
    subtitle: "甜而不腻 · 放松首选",
    cover: "https://readdy.ai/api/search-image?query=Pastel%20romantic%20editorial%20cover%20with%20cherry%20blossoms%20and%20desserts%2C%20bright%20airy%20magazine%20style&width=1200&height=700&seq=special-cover-04&orientation=landscape",
    intro: "忙碌了一天，只想看点甜甜的。这些轻松治愈的爱情剧，最适合配着饭一起看。",
    groups: [
      { title: "高甜爱情", desc: "小心别甜到蛀牙", dramaIds: [1, 8] },
      { title: "青春心动", desc: "关于夏天的每一次心跳", dramaIds: [3, 12] },
      { title: "慢生活治愈", desc: "让时间慢下来的故事", dramaIds: [10] },
    ],
    relatedSpecialIds: [1, 2],
  },
];